import React, { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchIssueReasonById from "../../hooks/useFetchReasonById";
import useFetchAllClassifications from "../../hooks/useFetchAllClassifications";
import { useBreadCrumbContext } from "../../contexts/BreadCrumbContext";
import { IconBtnEditBase } from "../../common/utils/icons";
import Loader from "../../components/Molecules/Loader/Loader";
import { useAuth } from "../../contexts/AuthContext";

const ViewReason: React.FC = () => {
  const { setCurrentBreadcrumbPage } = useBreadCrumbContext();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { id: reasonId } = useParams();

  const canEditReason = hasPermission("reason", "edit");

  const [formData, setFormData] = useState<any>({
    reason_name: "",
    issue_classification_name: "",
    is_active: true,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [reasonData] = useFetchIssueReasonById({
    setIsLoading,
    currentReasonId: reasonId,
  });

  // Fetch all classifications for lookup
  const [allClassifications] = useFetchAllClassifications({});

  // Helper function to get classification name by ID
  const getClassificationNameById = (
    classificationId: number | undefined
  ): string => {
    if (!classificationId || !allClassifications?.length) return "";
    const classification = allClassifications.find(
      (c: any) => c.id === classificationId
    );
    return classification?.issue_classification_name || "";
  };

  useEffect(() => {
    if (reasonData) {
      // Get classification name from the lookup
      const classificationName = getClassificationNameById(
        reasonData?.issue_classification_id
      );
      setFormData({
        reason_name: reasonData?.reason_name,
        issue_classification_name: classificationName,
        is_active: reasonData?.is_active,
      });
      setCurrentBreadcrumbPage({
        name: reasonData?.reason_name,
        id: reasonData?.id,
      });
    }
    return () => {
      setCurrentBreadcrumbPage({ name: "", id: null });
    };
  }, [reasonData, setCurrentBreadcrumbPage, allClassifications]);

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box>
        <Box className="text-box-card-white">
          <Box className="text-box-header">
            <h3>Reason Details</h3>
            {canEditReason && (
              <button
                className="btn-nostyle icon-btn-edit"
                onClick={() => navigate(`/reason/edit/${reasonId}`)}
              >
                <IconBtnEditBase
                  width={32}
                  height={32}
                  ariaLabel="Edit reason"
                />
              </button>
            )}
          </Box>
          <Grid container rowSpacing={1.5} columnSpacing={2.5}>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">Classification</label>
              <TextField
                type="text"
                name="issue_classification_name"
                value={formData?.issue_classification_name || ""}
                className="form-control read-only"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">Reason Name</label>
              <TextField
                type="text"
                name="reason_name"
                value={formData?.reason_name || ""}
                className="form-control read-only"
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <label className="label-text">Status</label>
              <TextField
                type="text"
                name="is_active"
                value={formData?.is_active ? "Active" : "Inactive"}
                className="form-control read-only"
                disabled
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ViewReason;
